<template>
    <div class="layer-card" :class="{ 'select-layer': isSelected, 'layer-disabled': !nowShow }" @click="selectLayer">
        <div class="layer-card-title">
            <span class="layer-visible"
                :class="{ 'icon-glyphicon-eye-open': nowShow, 'icon-glyphicon-eye-close': !nowShow }" title="隐藏/显示图层"
                @click="nowShow = !nowShow"></span>
            <div class="layer-title-text" v-show="!editTtle" @click="nowFold = !nowFold">{{ layerName }}</div>
            <div class="layer-title-edit" v-show="editTtle">
                <input type="text" class="layer-title-input" v-model="layerName">
                <span class="layer-title-edit-save icon-glyphicon-ok"
                    @click="updateLayerName(), editTtle = !editTtle"></span>
            </div>
            <!-- <span class="layer-zoom icon-glyphicon-screenshot" title="缩放至当前图层"></span> -->
            <span class="layer-title-trigger icon-glyphicon-pencil" title="编辑图层名称" @click="editTtle = !editTtle"></span>
        </div>
        <div class="layer-card-body" v-show="!nowFold">
            <div class="layer-card-tools">

                <!-- <div class="layer-style">
                    <span class="iconfont"></span>
                    <span class="text">样式设置</span>
                </div> -->

                <div class="data-list" @click="openDataTable">
                    <span class="icon-glyphicon-th"></span>
                    <span class="text">数据视图</span>
                </div>

                <div class="more-list" @click="delLayer">
                    <span class="icon-glyphicon-trash"></span>
                    <span class="text">删除图层</span>
                </div>
            </div>
            <div class="layer-card-features">
                <ul class="layer-legend">
                    <li class="features-panel-title">
                        <input type="checkbox" :id="toggleId" class="toggle-checkbox">
                        <label :for="toggleId" class="category-toggle-btn icon-icomoon-Triangle-1"></label>
                        <span class="category-info">
                            <div title="修改样式" class="category_style"
                                :class="{ 'category_style_point': item.type == '0' }">
                            </div>

                            <div class="category-name" title="区域" v-if="item.type == '2'">区域</div>
                            <div class="category-name" title="折线" v-if="item.type == '1'">折线</div>
                            <div class="category-name" title="散点图" v-if="item.type == '0'">散点图</div>

                            <div class="category-count">（<span>{{ objectList.length }}</span>）</div>
                        </span>
                        <div class="features-panel-list">
                            <ol class="category-child-ul">
                                <template v-for="(item, index) in objectList" :key="index">
                                    <li class="category-children-li" @click="flyToObject(index)">
                                        <span class="category-children-li-text" :title="item.title">{{ item.item.title
                                            }}</span>
                                    </li>
                                </template>
                            </ol>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <DataTablePanel ref="dataTable" :objectList="objectList" :layer="layer" />
    </div>
</template>

<script>
import { addDescription, getDescriptionList, updateLayer, delLayer, getConfigList } from '@/api/Common'
import { useMapStore } from '@/stores/mapStore';
import { MapUtils } from '@/utils/mapUtils';


import { h, createApp } from 'vue';


import markerIcon from '@/assets/images/icon/marker-icon.png';
import markerShadow from '@/assets/images/icon/marker-shadow.png';

import DataTablePanel from './DataTablePanel.vue';


// 引入 InfoPanel 组件
import InfoPanel from './InfoPanel.vue';


import { ElMessage, ElMessageBox } from 'element-plus'

export default {
    name: 'LayerCard',
    components: {
        InfoPanel,
        DataTablePanel
    },
    data() {
        return {
            editTtle: false,
            // descriptionList: [],
            layer: null,
            mapStore: null,
            objectList: [],
            nowShow: true,
            nowFold: true,
            layerName: ""
        }
    },
    props: {
        item: {
            type: Object, // 假设 item 是对象类型，根据实际情况调整
            required: true // 表示该参数是必需的
        },
        index: {
            type: Number, // 假设 item 是对象类型，根据实际情况调整
            required: true // 表示该参数是必需的 
        },
        fold: {
            type: Boolean, // 假设 item 是对象类型，根据实际情况调整
            required: true // 表示该参数是必需的
        },
        layerShow: {
            type: Boolean, // 假设 item 是对象类型，根据实际情况调整
            required: true // 表示该参数是必需的 
        }
    },
    computed: {
        toggleId() {
            return `toggle-${this.item.id}`; // 根据 item.id 生成唯一的 ID
        },
        isSelected() {
            try {
                if (this.mapStore && this.mapStore.selectLayer)
                    return this.item.id === this.mapStore.selectLayer.id; // 根据 mapStore.selectLayer.id 判断是否选中
                else
                    return false;
            } catch (e) {
                return false;
            }
        }
    },
    mounted() {
        this.mapStore = useMapStore();
        this.layer = this.mapStore.createLayer();

        // getConfigList().then(res => {
        //     console.log(res);
        //     if (res.code == 200) {

        //     }
        // })
        this.getDescriptionList();
        if (!this.mapStore.selectLayer) {
            this.selectLayer();
        }
        this.layerName = this.item.name;
    },
    watch: {
        fold: {
            immediate: true, // 初始化时立即执行一次
            handler(newVal) {
                this.nowFold = newVal;
            }
        },
        layerShow: {
            immediate: true, // 初始化时立即执行一次
            handler(newVal) {
                this.nowShow = newVal;
            }
        },
        nowShow: {
            immediate: true, // 初始化时立即执行一次
            handler(newVal) {
                this.toggleLayerVisibility();
            }
        }
    },
    // 在组件销毁前执行移除操作
    beforeDestroy() {
        this.removeAllObjects();
    },
    methods: {
        openDataTable() {
            this.$refs.dataTable.open();
        },
        addDescription(object) {
            // let that = this;
            // addDescription({
            //     "layerId": object.layerId,
            //     "title": object.title,
            //     "description": object.description,
            //     "type": object.type,
            //     "longitude": object.longitude,
            //     "latitude": object.latitude,
            //     "locations": [{
            //         "longitude": object.longitude,
            //         "latitude": object.latitude,
            //     }],
            // }).then(res => {
            //     console.log(res);
            //     that.descriptionList.
            // })
        },
        delLayer() {
            let that = this;
            let nIndex = this.index;
            ElMessageBox.confirm(
                '确认删除：' + this.item.name + '?',
                '删除图层',
                {
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning',
                }
            )
                .then(() => {
                    delLayer({
                        "id": that.item.id,
                    }).then(res => {
                        alert(res.msg);
                        if (res.code == 200) {
                            that.removeAllObjects();
                            that.$emit('layer-remove', { nIndex });
                        }
                    });
                })
                .catch(() => {

                })


        },
        //修改图层名称
        updateLayerName() {
            console.log(this.layerName);
            updateLayer({
                id: this.item.id,
                name: this.layerName,
            }).then(res => {

            })
        },
        toggleLayerVisibility() {
            if (this.layer && this.mapStore && this.mapStore.map) {
                if (this.nowShow) {
                    if (!this.mapStore.map.hasLayer(this.layer)) {
                        this.mapStore.map.addLayer(this.layer);
                    }
                } else {
                    if (this.mapStore.map.hasLayer(this.layer)) {
                        this.mapStore.map.removeLayer(this.layer);
                    }
                }
            }
        },
        getDescriptionList() {
            this.removeAllObjects();
            this.layer = this.mapStore.createLayer();
            let that = this;
            getDescriptionList({ "layerId": this.item.id }).then(res => {
                if (res.code == 200) {
                    //that.descriptionList = res.rows;
                    that.createObjectsFromData(res.rows);
                }
            })
        },
        createObjectsFromData(descriptionList) {

            if (this.layer) {
                let that = this;
                // 定义自定义图标和阴影图标
                // const customIcon = L.icon({
                //     iconUrl: markerIcon, // 替换为你的图标路径
                //     iconSize: [25, 41], // 图标大小
                //     iconAnchor: [12.5, 41], // 图标锚点
                //     popupAnchor: [-3, -76], // 弹出窗口锚点
                //     shadowUrl: markerShadow, // 替换为你的阴影图标路径
                //     shadowSize: [41, 41], // 阴影图标大小
                //     shadowAnchor: [12.5, 41] // 阴影图标锚点
                // });


                // console.log(descriptionList);


                descriptionList.forEach(item => {
                    let points = [];
                    let position = null;
                    let object = null;


                    const iconSizes = {
                        '0': {
                            size: [28, 36],
                            class: 'small-svg',
                        }, // 小
                        '1': {
                            size: [35, 45],
                            class: 'medium-font',
                        }, // 中
                        '2': {
                            size: [42, 54],
                            class: 'large-font',
                        }  // 大
                    };
                    const iconConfig = iconSizes[item.sizeState] || iconSizes['1'];
                    const size = iconConfig.size;
                    const className = iconConfig.class;


                    const customIcon = L.AwesomeMarkers.icon({
                        icon: 'bi-building-fill',
                        markerColor: 'steelblue',
                        popupAnchor: [0, -66], // 弹出窗口锚点
                        className: 'awesome-marker ' + className,
                        iconSize: size, // 设置图标大小
                        // extraClasses:'large-font'
                        // iconAnchor: iconAnchor,
                        // popupAnchor: popupAnchor
                    });





                    let locations = item.locations;
                    let type = item.type;

                    switch (type) {
                        case '0':
                            position = [item.latitude, item.longitude];
                            //position = item.description.split(",");
                            if (position.length == 2) {
                                // 创建点标记
                                object = L.marker(position, {
                                    icon: customIcon
                                }).addTo(this.layer);
                            }
                            break;
                        case '1':
                            points = locations;
                            if (points.length > 2) {
                                position = [];
                                for (let i = 0; i < points.length; i++) {
                                    position.push([points[i].latitude, points[i].longitude]);
                                }
                                // 创建线
                                object = L.polyline(position, { color: 'blue' }).addTo(this.layer);
                            }
                            break;
                        case '2':
                            points = locations;
                            if (points.length > 2) {
                                position = [];
                                position.push([]);
                                for (let i = 0; i < points.length; i++) {
                                    position[0].push([points[i].latitude, points[i].longitude]);
                                }
                                // 创建面
                                object = L.polygon(position, { color: 'green' }).addTo(this.layer);
                            }
                            break;
                        default:
                            position = [item.latitude, item.longitude];
                            //position = item.description.split(",");
                            if (position.length == 2) {

                                // 创建点标记
                                object = L.marker(position, {
                                    icon: customIcon
                                }).addTo(this.layer);

                            }
                            break;
                    }
                    if (object) {
                        object.item = item;
                        // 创建一个临时的 DOM 元素来挂载 InfoPanel 组件
                        const container = document.createElement('div');
                        // 设置 popup 容器的宽度
                        container.style.width = '300px';
                        // 使用 h 函数创建虚拟 DOM 节点
                        const vnode = h(InfoPanel, {
                            object: object,
                            layer: this,
                        });
                        // 使用 createApp 创建应用实例并挂载
                        const app = createApp({
                            render: () => vnode
                        });
                        app.mount(container);

                        // 创建 popup 并绑定到对象上
                        let popup = object.bindPopup(container);
                        object.on('click', function () {
                            that.mapStore.endEditObject();
                            popup.openPopup();
                        });

                        this.objectList.push(object);
                    }
                });
                this.$emit("object-sum", this.objectList.length);
            }
        },
        removeAllObjects() {
            this.$emit("object-reduce", this.objectList.length);
            this.objectList.forEach(obj => {
                if (obj) {
                    this.layer.removeLayer(obj);
                }
            });
            this.objectList = []; // 清空数组
            if (!this.mapStore) {
                this.mapStore = useMapStore();
            }
            this.mapStore.map.removeLayer(this.layer); // 从地图中移除图层

            this.layer = null; // 重置图层对象

        },
        // ... 已有代码 ...
        flyToObject(index) {
            const targetObject = this.objectList[index];
            if (targetObject) {

                let targetLatLng;
                if (targetObject instanceof L.Marker || targetObject instanceof L.Circle || targetObject instanceof L.CircleMarker) {
                    // 标记、圆形和圆形标记使用 getLatLng 方法
                    targetLatLng = targetObject.getLatLng();
                } else if (targetObject instanceof L.Polygon || targetObject instanceof L.Polyline) {
                    // 多边形和折线取第一个点
                    const latLngs = targetObject.getLatLngs();
                    targetLatLng = Array.isArray(latLngs[0]) ? latLngs[0][0] : latLngs[0];
                }
                if (targetObject.getPopup) {
                    targetObject.openPopup();
                }
                if (targetLatLng) {
                    // 使用地图实例的 flyTo 方法飞到目标位置
                    this.mapStore.map.flyTo([targetLatLng.lat, targetLatLng.lng]); // 15 为缩放级别，可按需调整
                }
            }
        },
        selectLayer() {
            this.mapStore.setSelectLayer(this.item);
            this.mapStore.setSelectLayerCard(this);
        }
    }
}

</script>

<style scoped>
.layer-disabled {
    opacity: 0.4;
}

/* 隐藏 checkbox */
.toggle-checkbox {
    display: none;
}

/* 默认隐藏 features-panel-list */
.features-panel-list {
    display: none;
    width: calc(100% - 20px);
    max-height: 462px;
    overflow-y: auto;

}

/* 当 checkbox 被选中时，显示 features-panel-list */
.toggle-checkbox:checked~.features-panel-list {
    display: block;
}

.select-layer {
    border: 2px solid #0095ff !important;
}

.category-toggle-btn {
    transform: rotate(0deg);
}

.toggle-checkbox:checked~.category-toggle-btn {
    transform: rotate(90deg);
}

.category-children-li {
    height: 22px;
    line-height: 22px;
    margin-top: 6px;
    margin-bottom: 6px;
    font-size: 12px;
    cursor: pointer;
    padding-left: 30px;
}

.category-children-li:hover {
    background: #d4eefe;
}

.layer-legend {
    overflow: visible;
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 32px;
}

.features-panel-title {
    position: relative;
    clear: both;
    height: auto;
    cursor: pointer;
    margin-top: 8px;
    list-style: none;
}


.layer-card {

    height: auto;
    width: 282px;
    position: relative;
    background-color: #fff;
    border: 2px solid transparent;

    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
    margin-top: 12px;
}

.layer-card-title {
    padding-left: 10px;
    padding-right: 10px;
    height: 32px;
    line-height: 32px;
    background-color: #f5f7fa;
    cursor: pointer;
}

.layer-visible {
    margin-top: 8px;
    color: #0095ff;
    float: left !important;
    cursor: pointer;
    font-size: 12px;
}

.layer-title-text {
    width: 200px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    float: left;
    margin-left: 8px;
    color: #576d8b;
    display: block;
}

.layer-zoom {
    float: right;
    margin-top: 8px;
    color: #576d8b;
    cursor: pointer;
    margin-left: 6px;
    font-size: 12px;
    display: none;
}

.layer-title-edit {
    float: left;
    width: 200px;
    margin-left: 12px;
    position: relative;
}

.layer-title-input {
    height: 24px;
    margin-top: 4px;
    padding-right: 24px;
    display: block;
    width: 100%;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.42857143;
    color: #555555;
    background-color: #ffffff;
    background-image: none;
    border: 1px solid #cccccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    -webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
    -o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
    transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
}

.layer-title-edit-save {
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
}

.layer-title-input:focus {
    border-color: #66afe9;
    outline: 0;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
}

.layer-title-trigger {
    float: right;
    margin-top: 8px;
    color: #576d8b;
    cursor: pointer;
    display: none;
}

.layer-card-title:hover .layer-zoom {
    display: inline-block !important;
}

.layer-card-title:hover .layer-title-trigger {
    display: inline-block !important;
}

.layer-card-body {
    padding-bottom: 6px;
}

.layer-card-tools {
    height: 32px;
    line-height: 24px;
    margin-left: 28px;
    border-bottom: 1px solid #c9d3e0;
    overflow: hidden;
}

.layer-style {
    padding: 0;
    margin-top: 6px;
    color: #0095ff;
    font-size: 12px;
    cursor: pointer;
    user-select: none;
    margin-right: 10px;
    width: 33.33333333%;
    float: left;

}

.layer-style .text {
    vertical-align: top;
}

.layer-card-body .text {
    font-size: 12px;
    color: #576d8b;
    width: 31%;
    margin-left: 2px;
}

.data-list {
    padding: 0;
    color: #0095ff;
    font-size: 12px;
    cursor: pointer;
    margin-top: 6px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 64px;
    margin-right: 18px;
    float: left;
    text-align: right;
}

.more-list {
    margin-top: 6px;
    padding-right: 10px !important;
    width: 74px;
    float: right;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    padding: 0;
    margin-top: 6px;
    color: #0095ff;
    font-size: 12px;
    cursor: pointer;
    text-align: right;
}


.category-toggle-btn {
    position: absolute;
    cursor: pointer;
    left: -18px;
    top: 5px;
    transform: scale(0.7);
    -webkit-transform: scale(0.7);
    -moz-transform: scale(0.7);
    -ms-transform: scale(0.7);
    -o-transform: scale(0.7);
}

.category_style {
    margin-top: 3px;
    height: 14px;
    width: 14px;
    border: 1px solid rgba(255, 0, 0, 0.8);
    background-color: rgba(255, 183, 59, 0.8);

    float: left;
}

.category_style_point {
    border-radius: 50%;
}

.category-info {
    display: inline-block;
    width: 184px;
    line-height: 22px
}

.category-info:hover {
    background: #87c4eb;
}

.category-name {
    display: inline-block;
    padding-left: 10px;
    padding-right: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    float: left;
    font-size: 12px;
    margin-left: 8px;
}

.category-count {
    float: left !important;
}
</style>